import type { TelegramUnavailableReason } from '../../shared/telegram/index.js';
import styles from './outside-telegram.module.css';

type OutsideTelegramProps = {
  reason: TelegramUnavailableReason;
};

const messages: Record<TelegramUnavailableReason, { title: string; description: string }> = {
  'outside-telegram': {
    title: 'Відкрийте через Telegram',
    description:
      'Клопотун працює всередині Telegram. Запустіть його з чату з ботом — у звичайному браузері він нічого не покаже.',
  },
  'startup-failed': {
    title: 'Не вдалося запуститися',
    description:
      'Telegram відповів не так, як очікувалося. Закрийте застосунок і спробуйте відкрити його ще раз.',
  },
  'no-init-data': {
    title: 'Не вдалося вас упізнати',
    description:
      'Telegram не передав дані запуску. Закрийте застосунок і відкрийте його з чату з ботом ще раз.',
  },
};

export const OutsideTelegram = ({ reason }: OutsideTelegramProps) => {
  const { title, description } = messages[reason];

  return (
    <main className={styles.outside}>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </main>
  );
};
